import { genericToolTip } from '@y42/gojs';
import * as go from 'gojs';
import { OrchestrationUINode } from '../../../../models/orchestration-diagram.model';
import { orchestrationDiagramConfig } from '../../../config/orchestration-diagram.config';
import { getOrchestrationDerivedNode } from '../../../utils/diagram-utils';
import { nodeToolTipVisibilityBinding } from '../utils/bindings';

export const nodeToolTip = () =>
  genericToolTip(
    orchestrationDiagramConfig.tooltip,
    [
      new go.Binding('text', '', (node: OrchestrationUINode, part: go.Part) => {
        const derivedNode = getOrchestrationDerivedNode(node, part.diagram!);
        const name = derivedNode?.entityName || '';
        return node.duplicate ? orchestrationDiagramConfig.tooltip.duplicateText : name;
      }),
    ],
    [nodeToolTipVisibilityBinding()],
  );
